<script setup lang="ts">
import { computed, ref, watch } from 'vue'

import { useMeasure } from '../../composables/use-measure'
import { useContentBlockStore } from '../stores/content-block-store'
import { ContentBlockType, getContentBlockComponent } from '../register-content-block'

const props = defineProps<{
  id: string
  type: string
}>()

const divRef = ref<HTMLDivElement | null>(null)

// Use the useMeasure composable to track the dimensions of the content block
const { dimensions } = useMeasure(divRef)

const id = computed(() => props.id)
const type = computed(() => getContentBlockComponent(props.type as ContentBlockType))
const contentBlockStore = useContentBlockStore()

watch([id, dimensions], ([newId, newDimensions]) => {
  contentBlockStore.updateContentBlockDimensions(newId, newDimensions)
})
</script>

<template>
  <div ref="divRef">
    <component :is="type"
               :id="id" />
  </div>
</template>
